import { render } from "./Menu.vue?vue&type=template&id=63d42f6a&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=63d42f6a&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=63d42f6a&lang=scss&scoped=true"
import "./Menu.vue?vue&type=style&index=2&id=63d42f6a&lang=scss"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d42f6a"]])

export default __exports__